import Store from "@/store/index";

import Calculations from "@/pages/calculations";
import SaveCalculation from "@/pages/calculations/create/save-calculation";
import Error404Calculation from "@/pages/calculations/create/calculation-error-404";

import NewCalculationProduction from "@/pages/calculations/create/tabs/production";
import NewCalculationDelivery from "@/pages/calculations/create/tabs/delivery";
import NewCalculationLateness from "@/pages/calculations/create/tabs/lateness";

export default [
    {
        path: "/",
        name: "calculations",
        component: Calculations,
        meta: {
            title: "Расчеты",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/calculation",
        name: "new-calculation",
        component: SaveCalculation,
        meta: {
            title: "Новый расчет",
        },
        children: [
            {
                path: "production",
                name: "save-calculation-production",
                component: NewCalculationProduction,
                meta: {
                    title: "Сохраненный расчет — производство",
                },
            },
            {
                path: "delivery",
                name: "save-calculation-delivery",
                component: NewCalculationDelivery,
                meta: {
                    title: "Сохраненный расчет — доставка",
                },
            },
            {
                path: "lateness",
                name: "save-calculation-lateness",
                component: NewCalculationLateness,
                meta: {
                    title: "Сохраненный расчет — опоздания",
                },
            },
        ],
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/calculation-error-404",
        name: "calculation-error-404",
        component: Error404Calculation,
        meta: {
            title: "Расчет не найден",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                next();
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
